import React from 'react'
import bsn from 'bootstrap.native'

export default class Alert extends React.Component {
    constructor() {
        super()
        this.onClose = this.onClose.bind(this)
    }
    componentDidMount() {
        if (this.element && !this.element.Alert) {
            var alert = new bsn.Alert(this.element)
        }
    }
    onClose() {
        if(this.props.onClose) {
            this.props.onClose()
        }
    }
    render() {
        return (
            <div className="alert alert-warning alert-dismissible fade in" role="alert" ref={e => this.modal = e}>
                <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={this.onClose}>
                    <span aria-hidden="true">×</span>
                </button>
                {this.props.children}
            </div>
        )
    }
} 


// WEBPACK FOOTER //
// ./components/Alert.jsx